/** Mirrors Server Enums.JournalEntryTypes */
export const JournalEntryTypes = {
  NormalJournal: 0,
  IsDepreciationJournal: 1,
  AdditionalJournalCommands: 2,
  VehicleManagement: 3,
};

export const JOURNAL_ENTRY_TYPE_OPTIONS = [
  { value: JournalEntryTypes.NormalJournal, label: 'NormalJournal' },
  { value: JournalEntryTypes.IsDepreciationJournal, label: 'IsDepreciationJournal' },
  { value: JournalEntryTypes.AdditionalJournalCommands, label: 'AdditionalJournalCommands' },
  { value: JournalEntryTypes.VehicleManagement, label: 'VehicleManagementJournal' },
];

export function journalEntryTypeLabel(type, t) {
  const v = type ?? JournalEntryTypes.NormalJournal;
  if (v === JournalEntryTypes.IsDepreciationJournal) return t('IsDepreciationJournal');
  if (v === JournalEntryTypes.AdditionalJournalCommands) return t('AdditionalJournalCommands');
  if (v === JournalEntryTypes.VehicleManagement) return t('VehicleManagementJournal');
  return t('NormalJournal');
}
